export default "__VITE_ASSET__14701de5__"